<template>
  <div class="result-teaser-data">
    <div class="message" v-html="resultTeaserData.supportText"></div>
    <div class="action">
      <button  @click="support">{{resultTeaserData.supportLinkText}}</button> 
    </div>
  </div>
</template>

<script>
export default {
    props:["resultTeaserData","translationHelper"],
    methods:{
      support(){
         window.open(this.resultTeaserData.supportLinkUrl, this.resultTeaserData.supportLinkTarget)
      }
    }
}
</script>
